// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"146":"css/tailwind","170":"css/app"}[chunkId] + ".css";
};